import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Tjenester() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Update page title and meta description
    document.title = 'Regnskapstjenester Oslo | Bokføring, Lønn, MVA | Easy Accounting AS';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Profesjonelle regnskapstjenester i Oslo: bokføring, regnskap, lønn, MVA-rapportering, årsregnskap og stiftelse av selskap. Statsautoriserte regnskapsførere. Fra 2.500 kr/mnd.');
    }
    
    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 'https://easy.no/tjenester');
    
    // Add Schema.org JSON-LD for Service + ItemList
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Service",
          "name": "Regnskapstjenester",
          "provider": {
            "@type": "Organization",
            "name": "Easy Accounting AS",
            "url": "https://easy.no",
            "telephone": "+47 954 87 639",
            "email": "post@easya.no",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Brynsveien 2",
              "postalCode": "0667",
              "addressLocality": "Oslo",
              "addressCountry": "NO"
            }
          },
          "serviceType": "Regnskapstjenester",
          "areaServed": {
            "@type": "City",
            "name": "Oslo"
          },
          "description": "Profesjonelle regnskapstjenester i Oslo: bokføring, regnskap, lønn, MVA-rapportering, årsregnskap og stiftelse av selskap."
        },
        {
          "@type": "ItemList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Service",
                "name": "Bokføring",
                "description": "Komplett bokføringstjeneste tilpasset din bedrift. Daglig bokføring av alle transaksjoner, bankavstemming og kontroll, fakturaregistrering og oppfølging.",
                "offers": {
                  "@type": "Offer",
                  "price": "2500",
                  "priceCurrency": "NOK",
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "price": "2500",
                    "priceCurrency": "NOK",
                    "unitText": "per måned"
                  }
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Service",
                "name": "Regnskap",
                "description": "Profesjonell regnskapsføring for full økonomisk oversikt. Månedsregnskap og rapporter, budsjett og prognoser, økonomisk rådgivning.",
                "offers": {
                  "@type": "Offer",
                  "price": "3500",
                  "priceCurrency": "NOK",
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "price": "3500",
                    "priceCurrency": "NOK",
                    "unitText": "per måned"
                  }
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Service",
                "name": "Rådgivning",
                "description": "Profesjonell økonomisk rådgivning for din bedrift. Strategisk økonomisk planlegging, investeringsanalyse, skatteoptimalisering.",
                "offers": {
                  "@type": "Offer",
                  "price": "1500",
                  "priceCurrency": "NOK",
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "price": "1500",
                    "priceCurrency": "NOK",
                    "unitText": "per time"
                  }
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Service",
                "name": "MVA-rapportering",
                "description": "Nøyaktig MVA-håndtering og innlevering. Bistandsberegning og kontroll, elektronisk innlevering, oppfølging av frister.",
                "offers": {
                  "@type": "Offer",
                  "price": "800",
                  "priceCurrency": "NOK",
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "price": "800",
                    "priceCurrency": "NOK",
                    "unitText": "per termin"
                  }
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Service",
                "name": "Årsregnskap",
                "description": "Komplett årsregnskap i henhold til norske standarder. Resultat- og balanseregnskap, noter og tilleggsopplysninger, innlevering til Brønnøysund.",
                "offers": {
                  "@type": "Offer",
                  "price": "8500",
                  "priceCurrency": "NOK"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 6,
              "item": {
                "@type": "Service",
                "name": "Stiftelse av selskap",
                "description": "Profesjonell hjelp med etablering av nye selskaper. Registrering i Foretaksregisteret, utarbeidelse av stiftelsesdokumenter, vedtekter og aksjonæravtaler.",
                "offers": {
                  "@type": "Offer",
                  "price": "2000",
                  "priceCurrency": "NOK"
                }
              }
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Hva koster regnskapsføring?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Regnskapsføring hos Easy Accounting AS starter fra 3.500 kr per måned. Prisen avhenger av bedriftens størrelse, antall transaksjoner og kompleksitet. Vi tilbyr skreddersydde løsninger tilpasset din bedrifts behov. Kontakt oss for et uforpliktende tilbud."
              }
            },
            {
              "@type": "Question",
              "name": "Hva er bokføring?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Bokføring er systematisk registrering av alle økonomiske transaksjoner i en bedrift. Dette inkluderer inntekter, utgifter, kjøp, salg og betalinger. Bokføring er lovpålagt for alle norske bedrifter og danner grunnlaget for regnskap, MVA-rapportering og årsregnskap. Hos Easy Accounting AS tilbyr vi komplett bokføringstjeneste fra 2.500 kr per måned."
              }
            },
            {
              "@type": "Question",
              "name": "Trenger jeg regnskapsfører?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Alle norske bedrifter er lovpålagt å føre regnskap i henhold til bokføringsloven. En autorisert regnskapsfører sikrer at regnskapet føres korrekt, at alle frister overholdes, og at du får profesjonell økonomisk rådgivning. Dette sparer deg tid, reduserer risiko for feil og straffer, og gir deg bedre økonomisk oversikt. Easy Accounting AS har statsautoriserte regnskapsførere med over 15 års erfaring."
              }
            },
            {
              "@type": "Question",
              "name": "Hva er MVA-rapportering?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "MVA-rapportering (merverdiavgift) er obligatorisk rapportering til Skatteetaten hvor bedrifter beregner og innbetaler MVA på salg og trekker fra MVA på kjøp. De fleste bedrifter rapporterer hver 2. måned (6 ganger per år). Feil i MVA-rapportering kan føre til gebyrer og tilleggsskatt. Easy Accounting AS håndterer all MVA-rapportering fra 800 kr per termin, inkludert beregning, kontroll og elektronisk innlevering."
              }
            }
          ]
        }
      ]
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical && existingCanonical.getAttribute('href') === 'https://easy.no/tjenester') {
        document.head.removeChild(existingCanonical);
      }
    };
  }, []);

  const services = [
    {
      icon: 'ri-calculator-line',
      title: 'Profesjonell bokføring Oslo',
      description: 'Komplett bokføringstjeneste tilpasset din bedrift',
      features: [
        'Daglig bokføring av alle transaksjoner',
        'Bankavstemming og kontroll',
        'Fakturaregistrering og oppfølging',
        'Rapportering og analyse'
      ],
      price: 'Fra 2.500 kr/mnd'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Regnskapsføring for bedrifter',
      description: 'Profesjonell regnskapsføring for full økonomisk oversikt',
      features: [
        'Månedsregnskap og rapporter',
        'Budsjett og prognoser',
        'Økonomisk rådgivning',
        'Oppfølging av nøkkeltall'
      ],
      price: 'Fra 3.500 kr/mnd'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Regnskapsrådgivning',
      description: 'Profesjonell økonomisk rådgivning for din bedrift',
      features: [
        'Strategisk økonomisk planlegging',
        'Investeringsanalyse og vurdering',
        'Skatteoptimalisering og -planlegging',
        'Forretningsutvikling og vekststrategier'
      ],
      price: '1.500 kr/time'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'MVA-rapportering Oslo',
      description: 'Nøyaktig MVA-håndtering og innlevering',
      features: [
        'Bistandsberegning og kontroll',
        'Elektronisk innlevering',
        'Oppfølging av frister',
        'Rådgivning ved endringer'
      ],
      price: 'Fra 800 kr/termin'
    },
    {
      icon: 'ri-folder-chart-line',
      title: 'Årsregnskap',
      description: 'Komplett årsregnskap i henhold til norske standarder',
      features: [
        'Resultat- og balanseregnskap',
        'Noter og tilleggsopplysninger',
        'Revisorkontroll hvis påkrevd',
        'Innlevering til Brønnøysund'
      ],
      price: 'Fra 8.500 kr'
    },
    {
      icon: 'ri-building-line',
      title: 'Stiftelse av selskap',
      description: 'Profesjonell hjelp med etablering av nye selskaper',
      features: [
        'Registrering i Foretaksregisteret',
        'Utarbeidelse av stiftelsesdokumenter',
        'Vedtekter og aksjonæravtaler',
        'Oppfølging av formaliteter'
      ],
      price: '2.000 kr'
    }
  ];

  const processes = [
    {
      step: '01',
      title: 'Kontakt',
      description: 'Ta kontakt for en uforpliktende samtale om dine behov'
    },
    {
      step: '02',
      title: 'Tilbud',
      description: 'Vi lager et skreddersydd tilbud basert på din bedrift'
    },
    {
      step: '03',
      title: 'Oppstart',
      description: 'Vi setter opp systemene og starter samarbeidet'
    },
    {
      step: '04',
      title: 'Oppfølging',
      description: 'Regelmessig oppfølging og rapportering'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-r from-blue-600 to-blue-800 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-20 h-20 bg-white/10 rounded-full animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}></div>
          <div className="absolute bottom-20 right-20 w-16 h-16 bg-white/10 rounded-full animate-bounce" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
        </div>
        <div className={`mx-auto max-w-7xl px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6 animate-fade-in-up">
            Regnskapstjenester i Oslo – Bokføring, Lønn &amp; MVA
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Profesjonelle regnskapstjenester fra statsautoriserte regnskapsførere. Vi tilbyr bokføring, regnskap, lønn, MVA-rapportering og årsregnskap til konkurransedyktige priser.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-gray-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">
              Våre regnskapstjenester
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Komplett spekter av regnskapstjenester for bedrifter i Oslo og omegn
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-all duration-300 hover:-translate-y-2 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-6 animate-pulse">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2 mt-0.5 animate-pulse"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="border-t pt-4">
                  <div className="font-semibold text-blue-600 text-lg mb-4">
                    {service.price}
                  </div>
                  <Link to="/kontakt">
                    <Button className="w-full hover:scale-105 transition-transform duration-300">
                      Få tilbud
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-16 animate-fade-in-up">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">
              Slik jobber vi
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              En enkel og strukturert prosess som sikrer at du får den beste tjenesten
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processes.map((process, index) => (
              <div 
                key={index} 
                className="text-center hover:-translate-y-2 transition-transform duration-300 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
                  <span className="text-2xl font-bold text-blue-600">{process.step}</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {process.title}
                </h3>
                <p className="text-gray-600">
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing CTA */}
      <section className="py-24 bg-blue-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-6 animate-fade-in-up">
            Trenger du et skreddersydd tilbud?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Hver bedrift er unik. Kontakt oss for et personlig tilbud tilpasset dine behov.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Link to="/kontakt">
              <Button size="lg" className="hover:scale-105 transition-transform duration-300">
                <i className="ri-phone-line mr-2"></i>
                Ring for tilbud
              </Button>
            </Link>
            <Link to="/kontakt">
              <Button variant="outline" size="lg" className="hover:scale-105 transition-transform duration-300">
                <i className="ri-mail-line mr-2"></i>
                Send forespørsel
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}